<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-client-page-heading">
                    <h3 class="fw-bold">{{ Imobiliaria.imoId ? 'Alterar imobiliária' : 'Nova imobiliária' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Imobiliárias</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Imobiliaria.imoId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Dados</v-tab>
                                    <div v-if="Imobiliaria.imoId != 0">
                                        <v-tab value="contrato" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Contrato</v-tab>
                                    </div>
                                    <div v-if="Imobiliaria.imoId != 0 && User.tpeid != 3 && Imobiliaria.planoCoberturaLivre == false">
                                        <v-tab value="planos" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Planos
                                            Cobertura</v-tab>
                                    </div>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <div class="gp-admin-form-header gp-realty-section-header">
                                            <span><v-icon size="20">mdi-office-building-outline</v-icon></span>
                                            <div><h4>Dados da imobiliária</h4><p>Preencha as informações cadastrais e os dados de contato.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Imobiliaria.imoId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="Imobiliaria.garId" :items="ListGarantidorasGeral"
                                                                item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhuma garantidora encontrada"
                                                                :disabled="User.tpeid === 1 || User.tpeid === 2 || User.tpeid === 3"
                                                                @update:model-value="BuscaParceiros()" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"
                                                        v-if="User.garid == 0 || User.tpeid === 1 || User.tpeid === 2">
                                                        <div class="form-group">
                                                            <label>Parceiro</label>
                                                            <v-autocomplete v-model="Imobiliaria.parId" :items="ListParceiros"
                                                                item-title="parNomeEmpresa" item-value="parId" density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum parceiro encontrado" :disabled="User.tpeid === 2" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Tipo Pessoa</label>
                                                            <select v-model="Imobiliaria.tpdId"
                                                                class="form-select form-control"
                                                                :disabled="User.tpeid == 3">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TiposDocumentos"
                                                                    :key="optionTipo.tpdId" :value="optionTipo.tpdId">{{
                                                                        optionTipo.tpdNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nº {{ Imobiliaria.tpdId == 1 ? 'CPF' :
                                                                'CNPJ' }}</label>
                                                            <input v-model="Imobiliaria.imoDocumento" type="text"
                                                                v-mask="documentoMask" :disabled="User.tpeid == 3"
                                                                @input="NormalizaDocumentoPessoa(Imobiliaria, 'imoDocumento')"
                                                                class="form-control"
                                                                :placeholder="Imobiliaria.tpdId == 1 ? 'CPF' : 'CNPJ'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome</label>
                                                            <input v-model="Imobiliaria.imoNomeEmpresa" type="text"
                                                                class="form-control"
                                                                :placeholder="Imobiliaria.tpdId == 1 ? 'Nome' : 'Nome Fantasia'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Imobiliaria.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Nome Responsável</label>
                                                            <input v-model="Imobiliaria.imoResponsavel" type="text"
                                                                class="form-control" placeholder="Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Imobiliaria.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>CPF Responsável</label>
                                                            <input v-model="Imobiliaria.imoCampoExtra1" type="text"
                                                                v-mask="'###.###.###-##'" class="form-control"
                                                                placeholder="CPF Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6" v-if="Imobiliaria.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Razão Social</label>
                                                            <input v-model="Imobiliaria.imoRazaoSocial" type="text"
                                                                class="form-control" placeholder="Razão Social" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Telefone</label>
                                                            <input v-model="Imobiliaria.imoTelefone"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Whatsapp</label>
                                                            <input v-model="Imobiliaria.imoWhatsapp"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input v-model="Imobiliaria.imoEmail" type="text"
                                                                class="form-control" :disabled="User.tpeid == 3"
                                                                placeholder="E-mail" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Creci</label>
                                                            <input v-model="Imobiliaria.imoCreci" type="text"
                                                                class="form-control" placeholder="Creci" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5">
                                                        <div class="form-group">
                                                            <label>Site</label>
                                                            <input v-model="Imobiliaria.imoCampoExtra2" type="text"
                                                                class="form-control" placeholder="Site" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12" v-if="ListaPlanosCobertura.length == 0 && User.tpeid != 3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                            <input
                                                                v-model="Imobiliaria.planoCoberturaLivre"
                                                                type="checkbox"
                                                                class="form-check-input"
                                                                id="checkboxEmiteNota"
                                                            />
                                                            <label class="form-check-label" for="checkboxEmiteNota">Plano Escolha Coberturas e Taxas Livre na Contratação</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    <!--endereço-->
                                    <section class="gp-realty-subsection">
                                        <div class="gp-admin-form-header gp-realty-section-header">
                                            <span><v-icon size="20">mdi-map-marker-outline</v-icon></span>
                                            <div><h4>Endereço</h4><p>Informe o CEP e complete os dados de localização da imobiliária.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Endereco.imeId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Imobiliaria</label>
                                                            <input v-model="Endereco.imoId" type="text"
                                                                class="form-control" placeholder="Id Imobiliaria" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CEP</label>
                                                            <input v-model="Endereco.imeCep" v-mask="'#####-###'"
                                                                type="text" class="form-control" placeholder="CEP" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group" style="padding-top: 35px;">
                                                            <button type="button" class="btn btn-info"
                                                                @click.prevent="Buscacep(Endereco.imeCep)"
                                                                style="color:#ffffff;">
                                                                Verificar CEP
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Endereço</label>
                                                            <input v-model="Endereco.imeEndereco" type="text"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Número</label>
                                                            <input v-model="Endereco.imeNumero" type="number"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Complemento</label>
                                                            <input v-model="Endereco.imeComplemento" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Estado</label>
                                                            <input v-model="Endereco.imeEstado" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Cidade</label>
                                                            <input v-model="Endereco.imeCidade" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Bairro</label>
                                                            <input v-model="Endereco.imeBairro" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </section>
                                    <!--endereco-->
                                    </v-window-item>
                                    <!--Contratos-->
                                    <v-window-item value="contrato">
                                        <div class="gp-admin-form-header gp-realty-section-header">
                                            <span><v-icon size="20">mdi-file-document-edit-outline</v-icon></span>
                                            <div><h4>Contrato</h4><p>Gerencie os modelos e documentos contratuais vinculados à imobiliária.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row" v-if="User.garid == 0 || User.tpeid == 1">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Contrato.gctId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Contrato.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Modelos de Contrato</label>
                                                            <select v-model="Contrato.cmcId"
                                                                class="form-select form-control">
                                                                <option value="">Selecione</option>
                                                                <option v-for="optionTipo in ListaContratos"
                                                                    :key="optionTipo.cmcId" :value="optionTipo.cmcId">{{
                                                                        optionTipo.cmcNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div>
                                                                <button type="button" class="btn btn-sm btn-success"
                                                                    style="color:#ffffff;margin-top:12px;"
                                                                    @click="ContratoAdd()">Adicionar</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="ListaContratosGeral!='' && ListaMeusContratos!=''">
                                                    <v-form>
                                                        <v-container>
                                                            <v-row>
                                                                <v-table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Contrato
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Status
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Data Assinatura
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Actions
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="item in ListaMeusContratos"
                                                                            :key="item.ictId">
                                                                            <td>{{ListaContratosGeral.filter(x =>
                                                                                x.cmcId == item.cmcId)[0].cmcNome}}
                                                                            </td>
                                                                            <td>{{ item.ictStatusEnvelope == null ? 'Não enviado p / assinatura' : item.ictDataAss == null ? 'Envelope encaminhado para coleta de assinaturas!' : 'Assinado' }}
                                                                            </td>
                                                                            <td>{{ item.ictDataAss }}</td>
                                                                            <td style="text-align:center;">
                                                                                <v-btn icon
                                                                                    @click.prevent="VisualizarContrato(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar</v-tooltip>
                                                                                </v-btn>
                                                                                <v-btn
                                                                                    v-if="item.ictStatusEnvelope == null"
                                                                                    class="btn btn-sm btn-info"
                                                                                    @click.prevent="EnviarAssinatura(item)"
                                                                                    variant="text">
                                                                                    Enviar p/ Assinatura
                                                                                </v-btn>
                                                                                <v-btn icon
                                                                                    @click.prevent="ExcluirContrato(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-delete-forever</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Excluir</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </v-table>
                                                            </v-row>
                                                        </v-container>
                                                    </v-form>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Contratos-->
                                </v-window>
                                    <!--Pagamentos-->
                                    <section v-if="tab === 'dados'" class="gp-realty-subsection gp-realty-bank-section">
                                        <div class="gp-admin-form-header gp-realty-section-header">
                                            <span><v-icon size="20">mdi-bank-outline</v-icon></span>
                                            <div><h4>Dados bancários</h4><p>Configure a conta e a chave Pix utilizadas nos pagamentos.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Pagamento.ipgId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Imobiliária</label>
                                                            <input v-model="Pagamento.imoId" type="text"
                                                                class="form-control" placeholder="Id Imobiliária" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Cód. Banco</label>
                                                            <input v-model="Pagamento.ipgSplitBanco" type="text"
                                                                class="form-control" placeholder="Código" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Nome Banco</label>
                                                            <input v-model="Pagamento.ipgSplitBancoNome" type="text"
                                                                class="form-control" placeholder="Nome Banco" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Agência</label>
                                                            <input v-model="Pagamento.ipgSplitAgencia" type="text"
                                                                class="form-control" placeholder="Agência" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Conta</label>
                                                            <input v-model="Pagamento.ipgSplitConta" type="text"
                                                                class="form-control" placeholder="Conta" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Tipo Conta</label>
                                                            <input v-model="Pagamento.ipgSplitTipoConta" type="text"
                                                                class="form-control" placeholder="Tipo Conta" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Titular</label>
                                                            <input v-model="Pagamento.ipgSplitTitularConta" type="text"
                                                                class="form-control" placeholder="Titular" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Documento</label>
                                                            <input v-model="Pagamento.ipgSplitTitularDocumento"
                                                                type="text" class="form-control"
                                                                placeholder="Documento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Chave Pix</label>
                                                            <input v-model="Pagamento.ipgSplitChavePix" type="text"
                                                                class="form-control" placeholder="Chave Pix" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </section>
                                    <!--Pagamentos-->
                                    <!--Planos Cobertura-->
                                <template v-if="tab === 'planos'">
                                <v-window v-model="tab">
                                    <v-window-item value="planos">
                                        <div class="gp-admin-form-header gp-realty-section-header">
                                            <span><v-icon size="20">mdi-shield-home-outline</v-icon></span>
                                            <div><h4>Planos de cobertura</h4><p>Configure as opções de cobertura e as respectivas tarifas.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row" v-if="User.tpeid != 3">
                                                     <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Inclua pelo menos uma opção de cada tipo.</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="Imobiliaria.planoCoberturaLivre==false">
                                                        <div class="form-group">
                                                            <label>Tipo</label>
                                                            <select v-model="PlanoCobertura.ipcTipoCobertura"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in ListaTipos"
                                                                    :key="index" :value="optionTipo.tipo">{{
                                                                    optionTipo.tipo }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"  v-if="Imobiliaria.planoCoberturaLivre==false">
                                                        <div class="form-group">
                                                            <label>Cobertura (Qtde Vezes)</label>
                                                            <input v-model.number="PlanoCobertura.ipcCobertura" type="number"
                                                                min="1" step="1" class="form-control" placeholder="Ex.: 12" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"  v-if="Imobiliaria.planoCoberturaLivre==false">
                                                        <div class="form-group">
                                                            <label>Taxa</label>
                                                            <div class="gp-percentage-input">
                                                                <input v-model="TaxaPlanoCobertura" type="text" inputmode="decimal"
                                                                    class="form-control" placeholder="Ex.: 9,5" />
                                                                <span>%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"  v-if="Imobiliaria.planoCoberturaLivre==false">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div>
                                                                <button v-if="PlanoCobertura.ipcId == 0" type="button" class="btn btn-sm btn-success"
                                                                    style="color:#ffffff;margin-top:12px;"
                                                                    @click="AddPlano()">Salvar</button>
                                                                <button v-else type="button" class="btn btn-sm btn-success"
                                                                    style="color:#ffffff;margin-top:12px;"
                                                                    @click="PutPlano()">Alterar</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="ListaPlanosCobertura != '' && Imobiliaria.planoCoberturaLivre==false">
                                                    <v-form>
                                                        <v-container>
                                                            <v-row>
                                                                <v-table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Tipo
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Cobertura
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Taxa
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="item in ListaPlanosCobertura"
                                                                            :key="item.ipcId">
                                                                            <td>{{ item.ipcTipoCobertura }}</td>
                                                                            <td>{{ item.ipcCobertura }}x</td>
                                                                            <td>{{ item.ipcPercentualGarantia*100 }}%</td>
                                                                            <td style="text-align:center;">
                                                                                <v-btn icon
                                                                                    @click.prevent="EditarPlano(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-file-edit</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Editar</v-tooltip>
                                                                                </v-btn>
                                                                                <v-btn icon
                                                                                    @click.prevent="ExcluirPlano(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-delete-forever</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Excluir</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </v-table>
                                                            </v-row>
                                                        </v-container>
                                                    </v-form>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Planos Cobertura-->
                                </v-window>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions" v-if="tab == 'dados'">
                        <div class="gp-realty-actions__left" v-if="Imobiliaria.imoId != 0 && User != '' && (User.garid == 0 || User.tpeid == 1)">
                            <button type="button" class="btn btn-outline-secondary" @click="CriarUsuarioEmail()">
                                <v-icon size="16">mdi-account-plus-outline</v-icon> Criar e notificar usuário de acesso
                            </button>
                        </div>
                        <div class="gp-realty-actions__right">
                            <a href="#" @click="EditCancel()" class="btn btn-outline-secondary">Cancelar</a>
                            <button v-if="Imobiliaria.imoId != 0" type="button" class="btn btn-success"
                                @click="Put(1)" :disabled="isSubmittingPut"><i class="fas fa-save"></i> Alterar</button>
                            <button v-else type="button" class="btn btn-success" @click="Add()"
                                :disabled="isSubmittingAdd"><i class="fas fa-save"></i> Salvar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Cadastro de imobiliárias</h3>
                    <ul class="breadcrumbs"><li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Imobiliárias</li></ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de imobiliárias</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :filter-columns="4" :headers="headers" :filter-source-headers="filtrosHeaders" :items="ListImobiliarias" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina"
                                    :show-export="User.garid == 0" file-name="imobiliarias">
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                            <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                            <button type="button" class="gp-table-action gp-action-delete" title="Excluir"
                                                v-if="User != '' && User.garid == 0" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'ImobiliariasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        EditView: false,
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
        },
        ListGarantidorasGeral: [],
        ListParceirosGeral: [],
        ListParceiros: [],
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        NomeTela: 'Imobiliarias',
        InfoTela: 'Lista de Imobiliarias',
        MostraGrid: true,
        headers: [],
        isSubmittingAdd: false,
        isSubmittingPut: false,
        //dados
        Imobiliaria: {
            imoId: 0,
            imoVisivel: null,
            imoDataCadastro: null,
            imoNomeEmpresa: '',
            imoRazaoSocial: '',
            tpdId: null,
            imoDocumento: '',
            imoTelefone: '',
            imoWhatsapp: '',
            imoResponsavel: '',
            imoEmail: '',
            imoAtivo: null,
            imoDataAniversario: null,
            imoCampoExtra1: '',
            imoCampoExtra2: '',
            imoCampoExtra3: '',
            imoCampoExtra4: '',
            imoCampoExtra5: '',
            imoTexto1: '',
            imoTexto2: '',
            imoTexto3: '',
            imoData1: null,
            imoData2: null,
            imoCreci: '',
            garId: null,
            parId: null,
            planoCoberturaLivre:false,
        },
        ListImobiliarias: [],
        ListImobiliariasGeral: [],
        TiposDocumentos: [],
        //dados
        //imagens
        selectedFile: null,
        //endereco
        Endereco: {
            imeId: 0,
            grtId: 0,
            cdtId: 0,
            imeEndereco: '',
            imeNumero: 0,
            imeComplemento: '',
            imeObsEndereco: '',
            imeCep: '',
            imePais: '',
            imeEstado: '',
            imeCidade: '',
            imeBairro: '',
            imoId: null
        },
        ListaEnderecos: [],
        EnderecoOriginal: null,
        showend: false,
        Retornocep: null,
        //endereco
        //contrato
        Contrato: {
            ictId: 0,
            grtId: 0,
            cdtId: 0,
            imoId: null,
            cmcId: '',
            ictUrlContrato: null,
            ictIp: null,
            ictDataAss: null, // Data inicializada como null
            ictRetornoJson: null,
            ictIdenvelope: null,
            ictStatusEnvelope: null
        },
        ListaContratos: [],
        ListaContratosGeral: [],
        ListaMeusContratos: [],
        ListUser: [],
        //contrato
        //contrato
        //Pagamentos
        Pagamento: {
            ipgId: 0,
            grtId: 0,
            cdtId: 0,
            imoId: null,
            ipgSplitBanco: '',
            ipgSplitBancoNome: '',
            ipgSplitAgencia: '',
            ipgSplitConta: '',
            ipgSplitTitularConta: '',
            ipgSplitTitularDocumento: '',
            ipgSplitChavePix: '',
            ipgSplitTipoConta: ''
        },
        ListaPagamentos: [],
        PagamentoOriginal: null,
        //Pagamentos
        Garantidora: {
            garId: 0,
            garVisivel: null,
            garDataCadastro: null,
            garNomeEmpresa: '',
            garRazaoSocial: '',
            tpdId: null,
            garDocumento: '',
            garTelefone: '',
            garWhatsapp: '',
            garResponsavel: '',
            garEmail: '',
            garAtivo: null,
            garDataAniversario: null,
            garCampoExtra1: '',
            garCampoExtra2: '',
            garCampoExtra3: '',
            garCampoExtra4: '',
            garCampoExtra5: '',
            garTexto1: '',
            garTexto2: '',
            garTexto3: '',
            garData1: null,
            garData2: null,
            garUrlLogo: ''
        },
        //PlanosCobertura
        PlanoCobertura: {
            ipcId: 0,
            imoId: 0,
            ipcCobertura: null,
            ipcPercentualGarantia: null,
            ipcTipoCobertura: null
        },
        TaxaPlanoCobertura: '',
        ListaPlanosCobertura: [],
        ListQtdemultiplicador: [
            { nome: '3x', value: 3 },
            { nome: '4x', value: 4 },
            { nome: '5x', value: 5 },
            { nome: '6x', value: 6 },
            { nome: '7x', value: 7 },
            { nome: '8x', value: 8 },
            { nome: '9x', value: 9 },
            { nome: '10x', value: 10 },
            { nome: '11x', value: 11 },
            { nome: '12x', value: 12 },
            { nome: '14x', value: 14 },
            { nome: '16x', value: 16 },
            { nome: '18x', value: 18 },
            { nome: '20x', value: 20 },
            { nome: '22x', value: 22 },
            { nome: '24x', value: 24 },
            { nome: '26x', value: 26 },
            { nome: '28x', value: 28 },
            { nome: '30x', value: 30 },
            { nome: '120x', value: 120 }
        ],
       ListaProdutosTaxas: [
                { nome: '3%', value: 0.03 },
                { nome: '4%', value: 0.04 },
                { nome: '5%', value: 0.05 },
                { nome: '6%', value: 0.06 },
                { nome: '7%', value: 0.07 },
                { nome: '8%', value: 0.08 },
                { nome: '9%', value: 0.09 },
                { nome: '9,5%', value: 0.095 },
                { nome: '10%', value: 0.10 },
                { nome: '10,5%', value: 0.105 },
                { nome: '11%', value: 0.11 },
                { nome: '11,5%', value: 0.115 },
                { nome: '12%', value: 0.12 },
                { nome: '12,5%', value: 0.125 },
                { nome: '13%', value: 0.13 },
                { nome: '13,5%', value: 0.135 },
                { nome: '14%', value: 0.14 },
                { nome: '14,5%', value: 0.145 },
                { nome: '15%', value: 0.15 },
                { nome: '15,5%', value: 0.155 },
                { nome: '16%', value: 0.16 },
                { nome: '16,5%', value: 0.165 },
                { nome: '17%', value: 0.17 },
                { nome: '17,5%', value: 0.175 },
                { nome: '18%', value: 0.18 },
                { nome: '18,5%', value: 0.185 },
                { nome: '19%', value: 0.19 },
                { nome: '19,5%', value: 0.195 },
                { nome: '20%', value: 0.20 },
                { nome: '25%', value: 0.25 },
                { nome: '30%', value: 0.30 }
            ],
        ListaTipos: [{ tipo: 'Comercial' }, { tipo: 'Residencial' }]
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().imoentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        isEmailValid(email) {
            if (!email) {
                return false;
            }
            // Se houver espaços antes ou depois, rejeita
            if (email !== email.trim()) {
                return false;
            }
            // Regex simples: texto + '@' + texto + '.' + texto
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },
        NormalizaDocumentoPessoa(pessoa, campoDocumento) {
            if (!pessoa || pessoa.tpdId !== 2 || !pessoa[campoDocumento]) return;

            const documento = pessoa[campoDocumento].toUpperCase().replace(/[^A-Z0-9./-]/g, '');
            if (documento !== pessoa[campoDocumento]) {
                pessoa[campoDocumento] = documento;
            }
        },
        NormalizaDocumento(value) {
            return String(value || '').toUpperCase().replace(/[.\-/\s]/g, '');
        },
        ValidaDocumentoPessoa(pessoa, campoDocumento) {
            if (pessoa.tpdId === 1) {
                return this.ValidaCpf(pessoa[campoDocumento]);
            }

            if (pessoa.tpdId === 2) {
                return this.ValidaCnpjAlfanumerico(pessoa[campoDocumento]);
            }

            return false;
        },
        ValidaCpf(value) {
            const cpf = this.NormalizaDocumento(value);
            if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false;

            const calcularDigito = (base, pesoInicial) => {
                const soma = base.split('').reduce((total, digito, index) => {
                    return total + parseInt(digito, 10) * (pesoInicial - index);
                }, 0);
                const resto = soma % 11;
                return resto < 2 ? '0' : String(11 - resto);
            };

            const primeiroDigito = calcularDigito(cpf.substring(0, 9), 10);
            const segundoDigito = calcularDigito(cpf.substring(0, 9) + primeiroDigito, 11);

            return cpf.substring(9) === primeiroDigito + segundoDigito;
        },
        ValidaCnpjAlfanumerico(value) {
            const cnpj = this.NormalizaDocumento(value);
            if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj) || /^([A-Z0-9])\1{13}$/.test(cnpj)) return false;

            const primeiroDigito = this.CalculaDigitoCnpjAlfanumerico(cnpj.substring(0, 12));
            const segundoDigito = this.CalculaDigitoCnpjAlfanumerico(cnpj.substring(0, 12) + primeiroDigito);

            return cnpj.substring(12) === primeiroDigito + segundoDigito;
        },
        CalculaDigitoCnpjAlfanumerico(base) {
            const pesos = base.length === 12
                ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            const soma = base.split('').reduce((total, char, index) => {
                return total + (char.charCodeAt(0) - 48) * pesos[index];
            }, 0);
            const resto = soma % 11;

            return resto < 2 ? '0' : String(11 - resto);
        },
        CarregaLista() {
            this.ListImobiliarias = this.ListImobiliariasGeral.map(item => {
                const gar = this.ListGarantidorasGeral.find(g => g.garId === item.garId);
                return {
                    ...item,
                    garNome: gar ? gar.garNomeEmpresa : ''
                };
            });
        },
        //imagens
        //imoantidora
        //edit
        EditNew() {
            this.EditView = true;
            this.Imobiliaria.imoId = 0;
            this.Imobiliaria.imoVisivel = null;
            this.Imobiliaria.imoDataCadastro = null;
            this.Imobiliaria.imoNomeEmpresa = '';
            this.Imobiliaria.imoRazaoSocial = '';
            this.Imobiliaria.tpdId = null;
            this.Imobiliaria.imoDocumento = '';
            this.Imobiliaria.imoTelefone = '';
            this.Imobiliaria.imoWhatsapp = '';
            this.Imobiliaria.imoResponsavel = '';
            this.Imobiliaria.imoEmail = '';
            this.Imobiliaria.imoAtivo = null;
            this.Imobiliaria.imoDataAniversario = null;
            this.Imobiliaria.imoCampoExtra1 = '';
            this.Imobiliaria.imoCampoExtra2 = '';
            this.Imobiliaria.imoCampoExtra3 = '';
            this.Imobiliaria.imoCampoExtra4 = '';
            this.Imobiliaria.imoCampoExtra5 = '';
            this.Imobiliaria.imoTexto1 = '';
            this.Imobiliaria.imoTexto2 = '';
            this.Imobiliaria.imoTexto3 = '';
            this.Imobiliaria.imoData1 = null;
            this.Imobiliaria.imoData2 = null;
            this.Imobiliaria.imoCreci = '';
            this.Imobiliaria.parId = null;
            this.Imobiliaria.garId = this.User.garid == 0 ? null : this.User.garid;
            this.Imobiliaria.planoCoberturaLivre = false;
            //endereco
            this.Endereco.imeId = 0;
            this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.imeEndereco = '';
            this.Endereco.imeNumero = 0;
            this.Endereco.imeComplemento = '';
            this.Endereco.imeObsEndereco = '';
            this.Endereco.imeCep = '';
            this.Endereco.imePais = '';
            this.Endereco.imeEstado = '';
            this.Endereco.imeCidade = '';
            this.Endereco.imeBairro = '';
            this.EnderecoOriginal = null;
            this.showend = false;
            this.Retornocep = null;
            //contrato
            this.Contrato.ictId = 0;
            this.Contrato.grtId = 0;
            this.Contrato.cdtId = 0;
            this.Contrato.cmcId = '';
            this.Contrato.ictUrlContrato = null;
            this.Contrato.ictIp = null;
            this.Contrato.ictDataAss = null; // Data inicializada como null
            this.Contrato.ictRetornoJson = null;
            this.Contrato.ictIdenvelope = null;
            this.Contrato.ictStatusEnvelope = null;
            this.ListaMeusContratos = [];
            //pagamento
            this.Pagamento.ipgId = 0;
            this.Pagamento.grtId = 0;
            this.Pagamento.cdtId = 0;
            this.Pagamento.ipgSplitBanco = '';
            this.Pagamento.ipgSplitBancoNome = '';
            this.Pagamento.ipgSplitAgencia = '';
            this.Pagamento.ipgSplitConta = '';
            this.Pagamento.ipgSplitTitularConta = '';
            this.Pagamento.ipgSplitTitularDocumento = '';
            this.Pagamento.ipgSplitChavePix = '';
            this.Pagamento.ipgSplitTipoConta = '';
            this.PagamentoOriginal = null;
            //planos
            this.PlanoCobertura.ipcId = 0;
            this.PlanoCobertura.ipcCobertura = null;
            this.PlanoCobertura.ipcPercentualGarantia = null;
            this.PlanoCobertura.ipcTipoCobertura = null;
            this.TaxaPlanoCobertura = '';
            this.tab = 'dados';
            this.BuscaParceiros();
        },
        EditCancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        EditGrid(item) {
            this.EditView = true;
            this.tab = 'dados';
            // console.log('item')
            //  console.log(item)
            if (item.imoId != '') {
                // Lógica imoa editar o item
                axios.get(`/Telas/Imobiliarias/GetById/` + item.imoId)
                    .then(response => {
                        this.Imobiliaria = response.data;

                        //carreimo endereços
                        this.CarregaEndereco(item.imoId);

                        //carrega parceiros
                        this.BuscaParceiros();

                        //carrega contratos
                        this.CarregaContratos(item.imoId)

                        //carregar pagamentos
                        this.CarregaPagamentos(item.imoId);

                        //carregar planos cobertura
                        this.CarregaPlanos(item.imoId)

                    });


            }
        },
        ValidaEnderecoUnificado() {
            const campos = [
                ['imeCep', 'Campo CEP Obrigatório.'],
                ['imeEndereco', 'Campo Endereço Obrigatório.'],
                ['imeNumero', 'Campo Número Obrigatório.'],
                ['imeEstado', 'Campo Estado Obrigatório.'],
                ['imeCidade', 'Campo Cidade Obrigatório.'],
                ['imeBairro', 'Campo Bairro Obrigatório.']
            ];
            const campoInvalido = campos.find(([campo]) =>
                this.Endereco[campo] === '' || this.Endereco[campo] === null || this.Endereco[campo] === undefined);
            if (campoInvalido) {
                this.$mensagemAviso(campoInvalido[1]);
                return false;
            }
            return true;
        },
        async SalvarDadosComplementares(imoId) {
            this.Endereco.imoId = imoId;
            this.Pagamento.imoId = imoId;

            const enderecoAlterado = !this.EnderecoOriginal ||
                JSON.stringify(this.Endereco) !== JSON.stringify(this.EnderecoOriginal);
            if (this.Endereco.imeId != 0 && enderecoAlterado) {
                await axios.put(`/Telas/Imobiliarias/UpdateImobiliariaEndereco`, this.Endereco);
                this.EnderecoOriginal = JSON.parse(JSON.stringify(this.Endereco));
            } else {
                if (this.Endereco.imeId == 0) {
                    const enderecoResponse = await axios.post(`/Telas/Imobiliarias/AddImobiliariaEndereco`, this.Endereco);
                    if (enderecoResponse.data > 0) this.Endereco.imeId = enderecoResponse.data;
                    this.EnderecoOriginal = JSON.parse(JSON.stringify(this.Endereco));
                }
            }

            const possuiDadosBancarios = this.Pagamento.ipgId != 0 || [
                this.Pagamento.ipgSplitBanco,
                this.Pagamento.ipgSplitBancoNome,
                this.Pagamento.ipgSplitAgencia,
                this.Pagamento.ipgSplitConta,
                this.Pagamento.ipgSplitTipoConta,
                this.Pagamento.ipgSplitTitularConta,
                this.Pagamento.ipgSplitTitularDocumento,
                this.Pagamento.ipgSplitChavePix
            ].some(valor => valor !== '' && valor !== null && valor !== undefined);

            if (possuiDadosBancarios) {
                const pagamentoAlterado = !this.PagamentoOriginal ||
                    JSON.stringify(this.Pagamento) !== JSON.stringify(this.PagamentoOriginal);
                if (this.Pagamento.ipgId != 0 && pagamentoAlterado) {
                    await axios.put(`/Telas/Imobiliarias/UpdateImobiliariaPagamento`, this.Pagamento);
                    this.PagamentoOriginal = JSON.parse(JSON.stringify(this.Pagamento));
                } else {
                    if (this.Pagamento.ipgId == 0) {
                        const pagamentoResponse = await axios.post(`/Telas/Imobiliarias/AddImobiliariaPagamento`, this.Pagamento);
                        if (pagamentoResponse.data > 0) this.Pagamento.ipgId = pagamentoResponse.data;
                        this.PagamentoOriginal = JSON.parse(JSON.stringify(this.Pagamento));
                    }
                }
            }
        },
        async Add() {
            if (this.isSubmittingAdd) return; // Proteção adicional
            this.isSubmittingAdd = true;

            if (this.Imobiliaria.garId === '' || this.Imobiliaria.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.tpdId === '' || this.Imobiliaria.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoDocumento === '' || this.Imobiliaria.imoDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (!this.ValidaDocumentoPessoa(this.Imobiliaria, 'imoDocumento')) {
                this.$mensagemAviso(this.Imobiliaria.tpdId === 1 ? "CPF invalido." : "CNPJ invalido.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoNomeEmpresa == '' || this.Imobiliaria.imoNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Imobiliaria.imoRazaoSocial == '' || this.Imobiliaria.imoRazaoSocial == null) && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo Razão Social Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoTelefone === '' || this.Imobiliaria.imoTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoWhatsapp === '' || this.Imobiliaria.imoWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoEmail === '' || this.Imobiliaria.imoEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (!this.isEmailValid(this.Imobiliaria.imoEmail)) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoResponsavel === '' && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoCampoExtra1 === '' && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Imobiliaria.imoCreci === '' || this.Imobiliaria.imoCreci === null) {
                this.$mensagemAviso("Campo Creci Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (!this.ValidaEnderecoUnificado()) {
                this.isSubmittingAdd = false;
            }
            else {
                if (this.Imobiliaria.imoVisivel === "" || this.Imobiliaria.imoVisivel === null) {
                    this.Imobiliaria.imoVisivel = true;
                }
                if (this.Imobiliaria.imoAtivo === "" || this.Imobiliaria.imoAtivo === null) {
                    this.Imobiliaria.imoAtivo = true;
                }

                if (this.Imobiliaria.parId === "" || this.Imobiliaria.parId === null) {
                    this.Imobiliaria.parId = null;
                }
                this.Imobiliaria.imoDataCadastro = this.$moment().format('YYYY-MM-DD')
                axios.post(`/Telas/Imobiliarias/Add`, this.Imobiliaria)
                    .then(async response => {
                        if (response.data > 0) {
                            this.Imobiliaria.imoId = response.data;
                            await this.SalvarDadosComplementares(this.Imobiliaria.imoId);
                            this.CarregaContratos(this.Imobiliaria.imoId);
                            this.$mensagemAvisoSucesso("Imobiliária, endereço e dados bancários incluídos com sucesso.")
                        }
                    }).finally(() => {
                        this.isSubmittingAdd = false; // Libera botão ao final
                    });

            }
        },
        Put(value) {
            if (this.isSubmittingPut) return; // Proteção adicional
            this.isSubmittingPut = true;

            if (this.Imobiliaria.garId === '' || this.Imobiliaria.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.tpdId === '' || this.Imobiliaria.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoDocumento === '' || this.Imobiliaria.imoDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (!this.ValidaDocumentoPessoa(this.Imobiliaria, 'imoDocumento')) {
                this.$mensagemAviso(this.Imobiliaria.tpdId === 1 ? "CPF invalido." : "CNPJ invalido.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoNomeEmpresa == '' || this.Imobiliaria.imoNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Imobiliaria.imoRazaoSocial == '' || this.Imobiliaria.imoRazaoSocial == null) && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo Razão Social Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoTelefone === '' || this.Imobiliaria.imoTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoWhatsapp === '' || this.Imobiliaria.imoWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoEmail === '' || this.Imobiliaria.imoEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (!this.isEmailValid(this.Imobiliaria.imoEmail)) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoResponsavel === '' && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoCampoExtra1 === '' && this.Imobiliaria.tpdId == 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.imoCreci === '' || this.Imobiliaria.imoCreci === null) {
                this.$mensagemAviso("Campo Creci Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (value == 1 && !this.ValidaEnderecoUnificado()) {
                this.isSubmittingPut = false;
            }
            else if (this.Imobiliaria.planoCoberturaLivre === false && this.ListaPlanosCobertura.length == 0) {
                this.$mensagemAviso("Necessário incluir planos de cobertura.")
                this.isSubmittingPut = false;
            }
            else {
                if (this.Imobiliaria.imoVisivel === "" || this.Imobiliaria.imoVisivel === null) {
                    this.Imobiliaria.imoVisivel = true;
                }
                if (this.Imobiliaria.imoAtivo === "" || this.Imobiliaria.imoAtivo === null) {
                    this.Imobiliaria.imoAtivo = true;
                }

                axios.put(`/Telas/Imobiliarias/Update`, this.Imobiliaria)
                    .then(async response => {
                        if (response.status == 200) {
                            if (value == 1){
                               await this.SalvarDadosComplementares(this.Imobiliaria.imoId);
                               this.$mensagemAvisoSucesso("Imobiliária, endereço e dados bancários alterados com sucesso.")
                               this.Get();
                            }
                        }
                    }).finally(() => {
                        this.isSubmittingPut = false; // Libera botão ao final
                    });
            }
        },
        CriarUsuarioEmail() {
            if (this.Imobiliaria.imoId == 0) {
                this.$mensagemAviso("Clique em salvar e preencha todos os dados antes de criar usuário.")
            }
            else if (this.ListaMeusContratos.length == 0) {
                this.$mensagemAviso("Campo Contrato - Modelo de contrato Obrigatório ser adicionado.")
            }
            else if (this.ListaMeusContratos.filter(x => x.gctIdEnvelope === null).length > 0) {
                this.$mensagemAviso("Contrato precisar ser enviado para assinatura.")
            }
            else {
                axios.get(`/Telas/Imobiliarias/GetByEmail/` + this.Imobiliaria.imoEmail)
                    .then(response => {
                        this.ListUser = response.data.filter(x => x.tpeId == 3);

                        if (this.ListUser.length == 0) {
                            var _usuario = {
                                cusId: 0,
                                cusNome: this.Imobiliaria.imoNomeEmpresa,
                                cusEmail: this.Imobiliaria.imoEmail,
                                cusTelefone: this.Imobiliaria.imoTelefone,
                                cusWhatsapp: this.Imobiliaria.imoWhatsapp,
                                cusSenha: this.Imobiliaria.imoWhatsapp.slice(-4),
                                cusDtCadastro: this.$moment(),
                                tusId: 9,
                                cusAtivo: true,
                                cusUrlImagem: '',
                                cliId: 0,
                                admTipoUsuario: { tusId: 9 },
                                tpeId: 3,
                                garId: this.Imobiliaria.garId,
                                pesId: this.Imobiliaria.imoId,
                            }
                            axios.post(`/Telas/Imobiliarias/AddCadastroUsuario`, _usuario)
                                .then(response => {
                                    if (response.data > 0) {
                                        _usuario.cusId = response.data;
                                        this.EnviaEmailCadastro(_usuario);
                                        this.$mensagemAviso("Usuário criado e notificado.")
                                    }
                                });
                        }
                        else {
                            this.$mensagemAviso("Usuário já possui cadastro ativo.")
                        }
                    });
            }

        },
        EnviaEmailCadastro(usuariocad) {
            axios.get(`/Telas/Imobiliarias/GetByIdMensagemPadrao/6?garId=${this.Imobiliaria.garId || 0}`)
                .then(response => {
                    this.templateEmail = response.data;
                    let _garNomeEmpresa = this.ListGarantidorasGeral.filter(x => x.garId == this.Imobiliaria.garId)[0].garNomeEmpresa;
                    let _dadosEmail = {
                        nomeDe: this.$GarantePayNome,
                        nomePara: usuariocad.cusNome,
                        assunto: 'Cadastro Imobiliaria - Sistema GarantePay',
                        destinatario: usuariocad.cusEmail,
                        emailResposta: this.$GarantePayEmail,
                        textoEmail: this.templateEmail.mpdTexto
                            .replace('[NomeImobiliaria]', this.Imobiliaria.imoNomeEmpresa)
                            .replace('[NomeUsuario]', this.Imobiliaria.imoResponsavel)
                            .replace('[NomeGarantidora]', _garNomeEmpresa)
                            .replace('[LinkAcesso]', this.$GarantePayLinkAcesso + this.Imobiliaria.garId + '/' + _garNomeEmpresa.toLowerCase().replaceAll(' ', '-').replaceAll('/', '').replaceAll('&', ''))
                            .replace('[UsuarioLogin]', usuariocad.cusEmail)
                            .replace('[SenhaAcesso]', usuariocad.cusSenha)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                        listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                    }
                    axios.post(`/Telas/Imobiliarias/Enviamail`, _dadosEmail);
                });
        },
        //edit
        async DeleteGrid(item) {
            await axios.get(`/Telas/Imobiliarias/GetByGarIdImoIdClientes/0/` + item.imoId)
                .then(response => {
                    if (response.data.filter(x => x.cliAtivo).length > 0) {
                        this.$mensagemAviso("Essa Imobiliaria já possui clientes cadastrados.")
                    }
                    else {
                        this.$mensagemConfirma('Tem certeza que deseja excluir?')
                            .then((result) => {
                                if (result.isConfirmed) {
                                    // Lógica imoa excluir o item
                                    const imoam1 = item.imoId;
                                    axios.delete(`/Telas/Imobiliarias/Delete/${imoam1}`)
                                        .then(response => {
                                            if (response.status == 200) {
                                                this.$mensagemAvisoSucesso("Registro Excluido.")
                                                this.Get();
                                            }
                                        });
                                }
                            });
                    }

                });
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Id", value: "imoId", sortable: true, });
            this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            this.headers.push({ text: "Imobiliária", value: "imoNomeEmpresa", sortable: true, });
            this.headers.push({ text: "Documento", value: "imoDocumento", sortable: true, });
            this.headers.push({ text: "Whatsapp", value: "imoWhatsapp", sortable: true, });
            this.headers.push({ text: "E-mail", value: "imoEmail", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        //imoantidora
        //endereco
        CarregaEndereco(_imoId) {
            axios.get(`/Telas/Imobiliarias/GetByImoIdImobiliariaEndereco/` + _imoId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.Endereco = response.data[0];
                        this.EnderecoOriginal = JSON.parse(JSON.stringify(this.Endereco));
                        this.showend = true;
                    }
                    else {
                        this.Endereco.imoId = _imoId;
                    }
                });
        },
        Buscacep(value) {
            if (value == "") {
                this.$mensagemAviso("Digite um CEP válido.")
            }
            else {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        if (data?.erro) throw new Error("CEP inexistente");
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.Endereco.imeEndereco = this.Retornocep.logradouro;
                            this.Endereco.imeNumero = null;
                            this.Endereco.imeComplemento = null;
                            this.Endereco.imeEstado = this.Retornocep.uf;
                            this.Endereco.imeCidade = this.Retornocep.localidade;
                            this.Endereco.imeBairro = this.Retornocep.bairro;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$mensagemErro(error?.message || "Não foi possível consultar o CEP. Tente novamente.");
                    });
            }
        },
        EnderecoAdd() {
            if (this.Endereco.imeCep == '') {
                this.$mensagemAviso("Campo CEP Obrigatório.")
            }
            else if (this.Endereco.imeEndereco === '') {
                this.$mensagemAviso("Campo Endereço Obrigatório.")
            }
            else if (this.Endereco.imeNumero === '') {
                this.$mensagemAviso("Campo Número Obrigatório.")
            }
            else if (this.Endereco.imeEstado === '') {
                this.$mensagemAviso("Campo Estado Obrigatório.")
            }
            else if (this.Endereco.imeCidade === '') {
                this.$mensagemAviso("Campo Cidade Obrigatório.")
            }
            else if (this.Endereco.imeBairro === '') {
                this.$mensagemAviso("Campo Bairro Obrigatório.")
            }
            else {
                axios.post(`/Telas/Imobiliarias/AddImobiliariaEndereco`, this.Endereco)
                    .then(response => {
                        if (response.data > 0) {
                            this.Endereco.imeId = response.data;
                            this.$mensagemAvisoSucesso("Endereço Incluído")
                        }
                    });
            }
        },
        EnderecoPut() {
            if (this.Endereco.imeCep == '') {
                this.$mensagemAviso("Campo CEP Obrigatório.")
            }
            else if (this.Endereco.imeEndereco === '') {
                this.$mensagemAviso("Campo Endereço Obrigatório.")
            }
            else if (this.Endereco.imeNumero === '') {
                this.$mensagemAviso("Campo Número Obrigatório.")
            }
            else if (this.Endereco.imeEstado === '') {
                this.$mensagemAviso("Campo Estado Obrigatório.")
            }
            else if (this.Endereco.imeCidade === '') {
                this.$mensagemAviso("Campo Cidade Obrigatório.")
            }
            else if (this.Endereco.imeBairro === '') {
                this.$mensagemAviso("Campo Bairro Obrigatório.")
            }
            else {
                axios.put(`/Telas/Imobiliarias/UpdateImobiliariaEndereco`, this.Endereco)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Endereço Alterado.")
                        }
                    });
            }
        },
        EnderecoCancel() {
            /*this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.gaeEndereco = '';
            this.Endereco.gaeNumero = null;
            this.Endereco.gaeComplemento = '';
            this.Endereco.gaeObsEndereco = '';
            this.Endereco.gaeCep = '';
            this.Endereco.gaePais = '';
            this.Endereco.gaeEstado = '';
            this.Endereco.gaeCidade = '';
            this.Endereco.gaeBairro = '';
            this.showend = false;*/
            this.$router.go(0);
        },
        //endereco
        //contratos
        CarregaContratos(_imoId) {
            axios.get(`/Telas/Imobiliarias/GetByImoIdImobiliariaContrato/` + _imoId)
                .then(response => {
                    this.ListaMeusContratos = response.data;
                    console.log('ListaMeusContratos')
                    console.log(this.ListaMeusContratos)
                    let _valida = this.ListaContratosGeral.filter(x => x.garId == this.Imobiliaria.garId);
                    if (_valida.length > 0) {
                        this.ListaContratos = _valida;
                    }
                    else {
                        this.ListaContratos = this.ListaContratosGeral.filter(x => x.garId == null || x.garId == '');
                    }
                });
        },
        async ContratoAdd() {
            if (this.Contrato.cmcId === '') {
                this.$mensagemAviso("Campo Modelo Contrato Obrigatório.")
            }
            else {
                //dadosContratante = imobiliária e dadosContratada = garantidora
                var _dadosContrato = {
                    TipoPessoa: 3,
                    CmcId: this.Contrato.cmcId,
                    IdContratante: this.Imobiliaria.imoId,
                    IdContratada: this.Imobiliaria.garId,
                    dadosContratacao: null
                }

                var _fileName = await this.Uploadpdf(_dadosContrato);

                this.Contrato.imoId = this.Imobiliaria.imoId;
                this.Contrato.ictUrlContrato = _fileName;

                await axios.post(`/Telas/Imobiliarias/AddImobiliariaContrato`, this.Contrato)
                    .then(response => {
                        if (response.data > 0) {
                            this.Contrato.ictId = response.data;
                            this.CarregaContratos(this.Contrato.imoId);
                            this.$mensagemAvisoSucesso("Contrato Incluído")
                        }
                    });
            }
        },
        ContratosPut() {
            if (this.Contrato.cmcId === '') {
                this.$mensagemAviso("Campo Modelo Contrato Obrigatório.")
            }
            else {
                axios.put(`/Telas/Imobiliarias/UpdateImobiliariaContrato`, this.Contrato)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Contrato Alterado.")
                        }
                    });
            }
        },
        ContratosCancel() {
            /*this.Contrato.grtId = 0;
            this.Contrato.cdtId = 0;
            this.Contrato.cmcId = null;
            this.Contrato.gctUrlContrato = '';
            this.Contrato.gctIp = '';
            this.Contrato.gctDataAss = null;
            this.Contrato.gctRetornoJson = '';*/
            this.$router.go(0);
        },
        VisualizarContrato(_contrato) {
            if (_contrato && _contrato.ictUrlContrato) {
                // Abre o PDF em uma nova aba
                this.openInNewTab(_contrato.ictUrlContrato);
            } else {
                console.error("URL do contrato não está disponível.");
            }
        },
        async Uploadpdf(dadosContrato) {
            const uploadResult = await axios.post(`/Telas/Imobiliarias/uploadContratoPdf`, dadosContrato);
            return uploadResult.data.nameFile;
        },
         buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/Imobiliarias/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        async EnviarAssinatura(item) {
            debugger;
            if (this.Endereco.imeCep == '') {
                this.$mensagemAviso("Campo CEP Obrigatório.")
            }
            else if (this.Endereco.imeEndereco === '') {
                this.$mensagemAviso("Campo Endereço Obrigatório.")
            }
            else if (this.Endereco.imeNumero === '') {
                this.$mensagemAviso("Campo Número Obrigatório.")
            }
            else if (this.Endereco.imeEstado === '') {
                this.$mensagemAviso("Campo Estado Obrigatório.")
            }
            else if (this.Endereco.imeCidade === '') {
                this.$mensagemAviso("Campo Cidade Obrigatório.")
            }
            else if (this.Endereco.imeBairro === '') {
                this.$mensagemAviso("Campo Bairro Obrigatório.")
            }
            else {
                axios.get(`/Telas/Imobiliarias/GetByGarIdGarantidoraAssinatura/` + this.Imobiliaria.garId)
                    .then(response => {
                        if (response.data.length > 0) {
                            this.Assinatura = response.data[0];
                            this.Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.Imobiliaria.garId)[0];

                            let idContrato = item.ictId;
                            let tpeId = 3;
                            let DadosEnvelopeRequest = {
                                idContrato: idContrato,
                                tpeId: tpeId,
                                token: this.Assinatura.gasToken,
                                envelopeDescricao: this.ListaContratos.filter(x => x.cmcId == item.cmcId)[0].cmcNome,
                                repositorioId: parseInt(this.Assinatura.gasIdRepositorio),
                                listaDocumentos: [{ UrlArquivo: item.ictUrlContrato }],
                                listaSignatariosEnvelopes: [{
                                    Ordem: 1,
                                    EmailSignatario: this.Imobiliaria.imoEmail,
                                    NomeSignatario: this.Imobiliaria.imoNomeEmpresa,
                                    TipoAssinatura: 1
                                },
                                {
                                    Ordem: 2,
                                    EmailSignatario: this.Garantidora.garEmail,
                                    NomeSignatario: this.Garantidora.garNomeEmpresa,
                                    TipoAssinatura: 1
                                }]
                            }

                              axios.post(`/Telas/Imobiliarias/CreateEnvelopeWithAllSteps`, DadosEnvelopeRequest)
                                            .then(response => {
                                                 let _result = response.data;
                                                if (_result.code === 1) {
                                                    this.CarregaContratos(this.Imobiliaria.imoId);
                                                    this.$mensagemAvisoSucesso("Processando envio da Assinatura");
                                                }
                                                else{
                                                    this.$mensagemErro(`Erro ao enviar assinatura (Status ${_result.code}): ${_result.message}`);
                                                }
                                            })
                                            .catch(error => {
                                                if (error.response) {
                                                // Erros retornados pelo servidor
                                                this.$mensagemErro(
                                                    `Erro ao enviar assinatura (Status ${error.response.status}): ${error.response.data}`
                                                );
                                                } else if (error.request) {
                                                // O servidor não respondeu
                                                this.$mensagemErro("Erro: Nenhuma resposta do servidor.", error.request);
                                                } else {
                                                // Erro ao configurar a requisição
                                                this.$mensagemErro("Erro ao configurar requisição:", error.message);
                                                }
                                            });
                       }
                    });
            }
        },
        ExcluirContrato(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // console.log('item')
                        //console.log(item)

                        if (item.ictIdEnvelope != null && item.ictIdEnvelope != '') {

                            axios.get(`/Telas/Imobiliarias/GetByGarIdGarantidoraAssinatura/` + this.Imobiliaria.garId)
                                .then(response => {
                                    if (response.data.length > 0) {
                                        this.Assinatura = response.data[0];
                                    }
                                    else {
                                        this.Assinatura = null;
                                    }
                                    let _dadosRemove = {
                                        token: this.Assinatura == null ? null : this.Assinatura.gasToken,
                                        idEnvelope: parseInt(item.ictIdEnvelope),
                                        tpeId: 3,
                                        reason: "Arquivo incorreto."
                                    }

                                    axios.post(`/Telas/Imobiliarias/RemoveEnvelope`, _dadosRemove)
                                        .then(response => {
                                            let _result = response.data;
                                            if (_result.code === 1) {
                                                this.$mensagemAvisoSucesso("Registro Excluido.")
                                                this.CarregaContratos(item.imoId);
                                            }
                                            else {
                                                this.$mensagemErro(`Erro ao excluir contrato/assinatura (Status ${_result.code}): ${_result.message}`);
                                            }
                                        });

                                });
                        } else {

                            const param1 = item.ictId;
                            axios.delete(`/Telas/Imobiliarias/DeleteContratoImobiliaria/${param1}`)
                                .then(response => {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.CarregaContratos(item.imoId);

                                });
                        }
                    }
                });
        },
        //contratos
        //pagamentos
        CarregaPagamentos(_imoId) {
            axios.get(`/Telas/Imobiliarias/GetByImoIdImobiliariaPagamento/` + _imoId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.Pagamento = response.data[0];
                        this.PagamentoOriginal = JSON.parse(JSON.stringify(this.Pagamento));
                    }
                    else {
                        this.Pagamento.imoId = _imoId;
                    }
                });
        },
        PagamentoAdd() {
            axios.post(`/Telas/Imobiliarias/AddImobiliariaPagamento`, this.Pagamento)
                .then(response => {
                    if (response.data > 0) {
                        this.Pagamento.ipgId = response.data;
                        this.$mensagemAvisoSucesso("Conta Bancária Incluída")
                    }
                });

        },
        PagamentoPut() {
            axios.put(`/Telas/Imobiliarias/UpdateImobiliariaPagamento`, this.Pagamento)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Conta Bancária Alterada.")
                    }
                });
        },
        PagamentoCancel() {
            /*this.Pagamento.grtId = 0;
            this.Pagamento.cdtId = 0;
            this.Pagamento.topId = null;
            this.Pagamento.gpgEmailAviso = '';
            this.Pagamento.gpgSplitToken = '';
            this.Pagamento.gpgSplitBanco = '';
            this.Pagamento.gpgSplitBancoNome = '';
            this.Pagamento.gpgSplitAgencia = '';
            this.Pagamento.gpgSplitConta = '';
            this.Pagamento.gpgSplitTitularConta = '';
            this.Pagamento.gpgSplitTitularDocumento = '';
            this.Pagamento.gpgSplitChavePix = '';
            this.Pagamento.gpgSplitTipoConta = '';*/
            this.$router.go(0);
        },
        //pagamentos
        //planosCobertura
        CarregaPlanos(_imoId) {
            axios.get(`/Telas/Imobiliarias/GetPlanosCoberturaByImoId/` + _imoId)
                .then(response => {
                        this.ListaPlanosCobertura = response.data;
                });
        },
        EditarPlano(item) {
            this.PlanoCobertura = { ...item };
            const percentual = Number(item.ipcPercentualGarantia) * 100;
            this.TaxaPlanoCobertura = Number(percentual.toFixed(6)).toString().replace('.', ',');
        },
        NormalizaValoresPlanoCobertura() {
            const cobertura = Number(this.PlanoCobertura.ipcCobertura);
            const taxaPercentual = Number(String(this.TaxaPlanoCobertura).trim().replace('%', '').replace(',', '.'));
            if (!Number.isInteger(cobertura) || cobertura <= 0) {
                this.$mensagemAviso("Informe uma cobertura válida em quantidade de vezes.");
                return false;
            }
            if (!Number.isFinite(taxaPercentual) || taxaPercentual <= 0) {
                this.$mensagemAviso("Informe uma taxa percentual válida.");
                return false;
            }
            this.PlanoCobertura.ipcCobertura = cobertura;
            this.PlanoCobertura.ipcPercentualGarantia = taxaPercentual / 100;
            return true;
        },
        ExcluirPlano(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.ipcId;
                        axios.delete(`/Telas/Imobiliarias/DeletePlanosCobertura/${param1}`)
                            .then(response => {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                      this.CarregaPlanos(this.Imobiliaria.imoId);
                                        this.PlanoCobertura.ipcId = 0;
                                        this.PlanoCobertura.ipcCobertura = null;
                                        this.PlanoCobertura.ipcPercentualGarantia = null;
                                        this.PlanoCobertura.ipcTipoCobertura = null;
                                        this.TaxaPlanoCobertura = '';
                                
                            });
                    }
                });
        },
        AddPlano() {
            if (this.PlanoCobertura.ipcTipoCobertura === '' || this.PlanoCobertura.ipcTipoCobertura === null) {
                this.$mensagemAviso("Campo Tipo Obrigatório.")
            }
            else if (!this.NormalizaValoresPlanoCobertura()) {
                return;
            }
            else if (this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == this.PlanoCobertura.ipcTipoCobertura &&
                                                          x.ipcCobertura == this.PlanoCobertura.ipcCobertura).length > 0)
            {
                this.$mensagemAviso("Já existe uma taxa para essa cobertura.")
            }
            else {
                this.PlanoCobertura.imoId = this.Imobiliaria.imoId;
                axios.post(`/Telas/Imobiliarias/AddPlanosCobertura`, this.PlanoCobertura)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro incluído")
                            this.CarregaPlanos(this.Imobiliaria.imoId);
                            this.Put(0);
                            this.PlanoCobertura.ipcId = 0;
                            this.PlanoCobertura.ipcCobertura = null;
                            this.PlanoCobertura.ipcPercentualGarantia = null;
                            this.PlanoCobertura.ipcTipoCobertura = null;
                            this.TaxaPlanoCobertura = '';
                        }
                    });
            }
        },
        PutPlano(){
           if (this.PlanoCobertura.ipcTipoCobertura === '' || this.PlanoCobertura.ipcTipoCobertura === null) {
                this.$mensagemAviso("Campo Tipo Obrigatório.")
            }
            else if (!this.NormalizaValoresPlanoCobertura()) {
                return;
            }
            else if (this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == this.PlanoCobertura.ipcTipoCobertura &&
                                                          x.ipcCobertura == this.PlanoCobertura.ipcCobertura && 
                                                        x.ipcId != this.PlanoCobertura.ipcId).length > 0)
            {
                this.$mensagemAviso("Já existe uma taxa para essa cobertura.")
            }
            else {
                this.PlanoCobertura.imoId = this.Imobiliaria.imoId;
                //console.log('this.PlanoCobertura')
                //console.log(this.PlanoCobertura)
                axios.put(`/Telas/Imobiliarias/UpdatePlanosCobertura`, this.PlanoCobertura)
                    .then(response => {
                            this.$mensagemAvisoSucesso("Registro alterado.")
                            this.CarregaPlanos(this.Imobiliaria.imoId);
                            this.PlanoCobertura.ipcId = 0;
                            this.PlanoCobertura.ipcCobertura = null;
                            this.PlanoCobertura.ipcPercentualGarantia = null;
                            this.PlanoCobertura.ipcTipoCobertura = null;
                            this.TaxaPlanoCobertura = '';
                    });
            }
        },
        //PlanosCobertura
        BuscaParceiros() {
            this.ListParceiros = this.ListParceirosGeral.filter(x => x.garId == this.Imobiliaria.garId);
        },
        exportCSV() {
            if (this.ListImobiliarias.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            const csvHeader = this.headers
                .map(h => h.text)
                .join(";") + "\n";

            // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
            const keys = this.headers
                .map(h => h.value);


            const csvRows = this.ListImobiliarias
                .map(item => {
                    return keys
                        .map(key => {
                            // para os demais campos, pega direto do item
                            return item[key] != null ? item[key] : "";
                        })
                        .join(";");
                })
                .join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioListaImobiliarias.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async Get() {
            await axios.get(`/Telas/Imobiliarias/GetDados`)
                .then(response => {
                    this.ListGarantidorasGeral = response.data.garantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(b.garNomeEmpresa, 'pt-BR', { sensitivity: 'base' }));
                    this.EditView = false;
                    this.ListImobiliariasGeral = response.data.imobiliarias;
                    //console.log(' this.ListImobiliariasGeral')
                    //console.log( this.ListImobiliariasGeral)
                    this.User.tpeid = response.data.tpeId
                    this.User.garid = response.data.garId
                    this.User.pesid = response.data.pesId
                    this.TiposDocumentos = response.data.tipoDocumentos.filter(x => x.tpdAtivo);
                    this.ListaContratosGeral = response.data.modelosContratos;
                    this.ListParceirosGeral = response.data.parceiros.filter(x => x.parAtivo).sort((a, b) =>
                        a.parNomeEmpresa.localeCompare(b.parNomeEmpresa, 'pt-BR', { sensitivity: 'base' }));
                    this.CarregaLista();
                    this.montaGrid();
                    if (this.User.tpeid == 3) { //imobiliaria mesmo
                        const itemImobiliariaLogada = { imoId: this.User.pesid };
                        this.EditGrid(itemImobiliariaLogada);
                    }

                });
        }
    },
    created() {
        this.Get();
    },
    computed: {
        filtrosHeaders() {
            if (this.User.tpeid == 3) {
                return this.headers.filter(header => !['garNome', 'imoNomeEmpresa'].includes(header.value));
            }

            if (this.User.tpeid == 1) {
                return this.headers.filter(header => header.value != 'garNome');
            }

            return this.headers;
        },
        documentoMask() {
            return this.Imobiliaria.tpdId === 1 ? '###.###.###-##' : 'XX.XXX.XXX/XXXX-##';
        }
    }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
.gp-realty-section-header { margin: 8px 12px 0; border: 1px solid #e1d9cd; border-radius: 12px 12px 0 0; background: #fcf8f2; }
.gp-realty-section-header + .v-form { margin: 0 12px 8px; border: 1px solid #e1d9cd; border-top: 0; border-radius: 0 0 12px 12px; background: #fffdf9; }
.gp-realty-section-header + .v-form :deep(.v-container) { max-width: none; padding: 14px 16px 10px; }
.gp-realty-subsection { display: block; margin: 10px 12px 14px; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 12px; background: #fffdf9; }
.gp-realty-subsection .gp-realty-section-header { margin: 0; border: 0; border-bottom: 1px solid #e1d9cd; border-radius: 0; }
.gp-realty-subsection .gp-realty-section-header + .v-form { margin: 0; border: 0; border-radius: 0; }
.gp-realty-actions__left { margin-right: auto; }
.gp-realty-actions__right { display: flex; align-items: center; gap: 8px; }
.gp-percentage-input { position: relative; }
.gp-percentage-input .form-control { padding-right: 34px; }
.gp-percentage-input span { position: absolute; top: 50%; right: 12px; color: #6f7885; font-size: 12px; transform: translateY(-50%); pointer-events: none; }
@media (max-width: 767.98px) {
    .gp-realty-section-header, .gp-realty-section-header + .v-form, .gp-realty-subsection { margin-right: 0; margin-left: 0; }
    .gp-realty-actions__left, .gp-realty-actions__right { width: 100%; }
    .gp-realty-actions__right { justify-content: flex-end; }
}
</style>
